import { Text } from '@/hen-ui/atomics/Text';
import { Flex } from '@/hen-ui/composites/Flex';
import { LogoBox } from '@/hen-ui/composites/LogoBox';

interface CareerExplorerRecommendationCardHeaderProps {
  title: string;
  titleId: string;
  partnerId: string;
  partnerLogoUrl: string;
  partnerLogoAlt?: string;
}

export const CareerExplorerRecommendationCardHeader = ({
  partnerId,
  partnerLogoAlt,
  partnerLogoUrl,
  title,
  titleId,
}: CareerExplorerRecommendationCardHeaderProps) => (
  <Flex
    direction='row'
    gap='xxs'
    align='center'
    width='full'
    className='min-w-0 pr-xs'
  >
    <LogoBox
      src={partnerLogoUrl}
      alt=''
      aria-hidden
      size='fill'
      shadow='none'
      className='h-10.5 w-20 flex-none border border-neutral-200 p-xxs'
    />
    {partnerLogoAlt ? (
      <Text id={partnerId} tag='span' variant='b5' visuallyHidden>
        {partnerLogoAlt}
      </Text>
    ) : null}
    <Text
      id={titleId}
      tag='span'
      variant='b4'
      weight='bold'
      lines={2}
      className='min-w-0 flex-1 text-left text-neutral-900'
    >
      {title}
    </Text>
  </Flex>
);
